import { BaseButton, type BaseButtonProps } from '@/components/common/base-button';
import clsx from 'clsx';
import styles from './styles.module.scss';

type HomeButtonProps = BaseButtonProps & {
    prefix?: React.ReactNode;
};

export const HomeButton = ({ children, prefix, ...props }: HomeButtonProps) => {
    return (
        <BaseButton {...props} className={clsx(styles['home-button'])}>
            {prefix && <span className="flex-shrink-0">{prefix}</span>}
            <span>{children}</span>
        </BaseButton>
    );
};
